import { canv } from "@/canv/global";
import { matrixTranslate } from "@/canv/utils";
import { eventEmitter } from "@/eventEmitter";
import { rafThrottle } from "@/helpers/rafThrottle";
import { t } from "@/i18n";
import { toolBase } from "@/tools/toolBase";

export class DragTool extends toolBase {
    getToolTipName() {
        return t("tools.hand");
    }

    select() {
        this.isSelected = true;
        this.changeCursor();
    }

    unselect() {
        this.isSelected = false;
        this.changeCursor();
    }

    changeCursor() {
        const canvas = document.getElementsByTagName("canvas");

        if (this.isSelected) {
            canvas[0].classList.add("grabble");
        } else {
            canvas[0].classList.remove("grabble");
        }
    }

    updateMinimap = rafThrottle(() => {
        eventEmitter.dispatch("minimap.update", { needUpdate: true });
    });

    TryAction(type: string) {
        if (type === "mousedown") {
            this.mouseDown = true;
        } else if (type === "mousemove") {
            if (!this.mouseDown) {
                return;
            }

            if ((canv.actionManager.lastMoveEvt as PointerEvent)?.pointerType === "mouse") {
                const evt = canv.actionManager.lastMoveEvt as PointerEvent;

                matrixTranslate(evt.movementX * canv.dpr, evt.movementY * canv.dpr);
            } else if (
                canv.actionManager.lastTouches.length >= 1 &&
                canv.actionManager.prevTouches.length >= 1
            ) {
                const dx =
                    canv.actionManager.lastTouches[0].clientX -
                    canv.actionManager.prevTouches[0].clientX;
                const dy =
                    canv.actionManager.lastTouches[0].clientY -
                    canv.actionManager.prevTouches[0].clientY;
                matrixTranslate(dx * canv.dpr, dy * canv.dpr);
            }

            canv.ctx.setTransform(canv.m[0], 0, 0, canv.m[3], canv.m[4], canv.m[5]);
            this.updateMinimap();

            canv.redraw();
        } else if (type === "mouseup") {
            this.mouseDown = false;
            eventEmitter.dispatch("minimap.update", { needUpdate: true });
        }

        canv.redraw();
    }

    draw() {}

    isSelected = false;
    name = "dragTool";
    mouseDown = false;
}
